module.exports = __webpack_public_path__ + "media/images/page/step_img05-7fd62b307d477a12289569424136701f.svg";